import getStore from '../store/store';
import { default as getNotesSDK } from '../utils/getNotesSDK';
import { NoteColor } from '@notes/sticky-notes-sdk';
import { action } from 'satcheljs/lib/legacy';

export default action('changeNoteColor')(function changeNoteColor(newColor: string) {
    getNotesSDK().updateNoteColor(getStore().selectedNoteId, newColor as NoteColor);
});
